import { useQuery, useMutation, useQueryClient } from 'react-query';

import { API_KEYS } from '../../constants/endpoints';
import api from '../../utils/api';
import { useVpSnackbar } from '../../vp-ui';

const fetchApiKeys = () => api.get(API_KEYS);

export const useFetchApiKeys = () => {
  const { addSnackbarError } = useVpSnackbar();
  return useQuery([API_KEYS], fetchApiKeys, {
    onError: (error) => {
      addSnackbarError({ error, title: 'Error retrieving api keys' });
    }
  });
};

const putApiKeys = ({ userId }) => api.put(`${API_KEYS}/${userId}`);
export const usePutApiKeys = () => {
  const { addSnackbarError, addSnackbarSuccess } = useVpSnackbar();
  const queryClient = useQueryClient();

  return useMutation(putApiKeys, {
    onError: (error) => {
      addSnackbarError({ error, title: 'Error regenerating api key' });
    },
    onSuccess: () => {
      queryClient.invalidateQueries(API_KEYS);
      addSnackbarSuccess({ message: 'Successfully Regenerated Api Token' });
    }
  });
};

const postApiKeys = () => api.post(`${API_KEYS}`);
export const usePostApiKeys = () => {
  const { addSnackbarError, addSnackbarSuccess } = useVpSnackbar();
  const queryClient = useQueryClient();

  return useMutation(postApiKeys, {
    onError: (error) => {
      addSnackbarError({ error, title: 'Error generating api key' });
    },
    onSuccess: () => {
      queryClient.invalidateQueries(API_KEYS);
      addSnackbarSuccess({ message: 'Successfully Generated Api Token' });
    }
  });
};



// WEBPACK FOOTER //
// ./src/hooks/react-query/useApiKeys.js